export default {"src":"/_next/static/media/PTEN.d4261ca7.svg","height":18,"width":18};